<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-md-12">
                <div
                    class="alert alert-danger"
                >O tamanho das imagens pode impactar diretamente na performance e tempo de carregamento do aplicativo.</div>
                <form @submit.prevent="save">
                    <div class="card">
                        <div class="card-header">
                            <i class="fa fa-menu"></i> Post
                        </div>
                        <div class="card-block form form-horizontal">
                            <div class="form-group row">
                                <div
                                    class="col-md-4"
                                    :class="{ 'dropdown-has-error': $v.model.id_categoria.$error }"
                                >
                                    <label>Categoria*</label>
                                    <select-api
                                        v-model="model.id_categoria"
                                        :endpoint="'/categorias/pesquisa'"
                                        :opt-text="'nome'"
                                        :select-option="true"
                                    ></select-api>
                                </div>

                                <div
                                    class="col-md-4"
                                    :class="{ 'dropdown-has-error': $v.model.tipo.$error }"
                                >
                                    <label>Tipo*</label>
                                    <Select2
                                        placeholder="Selecione"
                                        v-model="model.tipo"
                                        :options="tipos"
                                        opt-id="id"
                                    >
                                        <option value selected>Selecione</option>
                                    </Select2>
                                </div>
                            </div>

                            <div class="form-group row">
                                <div
                                    class="col-md-6"
                                    :class="{ 'has-danger': $v.model.titulo.$error }"
                                >
                                    <label>Titulo*</label>
                                    <input
                                        type="text"
                                        maxlength="100"
                                        class="form-control"
                                        v-model="model.titulo"
                                    />
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-md-6">
                                    <label>Autor</label>
                                    <input
                                        type="text"
                                        maxlength="100"
                                        class="form-control"
                                        v-model="model.autor"
                                    />
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-md-4">
                                    <label>Data</label>
                                    <input-datepicker
                                        :disabled="false"
                                        :readonly="false"
                                        :group="false"
                                        :autoclose="true"
                                        :required="true"
                                        v-model="model.data"
                                    ></input-datepicker>
                                </div>

                                <div class="col-md-4" v-if="model.tipo === 'V'">
                                    <label>Url</label>
                                    <input
                                        type="text"
                                        maxlength="100"
                                        class="form-control"
                                        v-model="model.url"
                                    />
                                </div>
                            </div>
                            <div class="form-group row">
                              <div class="col-md-4">
                                <label>Idioma</label>
                                <Select2
                                    placeholder="Selecione"
                                    v-model="model.idioma"
                                    :options="tiposIdioma"
                                    opt-id="idioma"
                                >
                                    <option value selected>Selecione</option>
                                </Select2>
                              </div>
                            </div>
                            <div class="form-group row">
                                <div class="col-md-12">
                                    <label>Conteúdo</label>
                                    <vue-editor
                                        id="editor"
                                        useCustomImageHandler
                                        @imageAdded="handleImageAdded"
                                        v-model="model.conteudo"
                                    ></vue-editor>
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-md-12">
                                    <div class="alert alert-warning">
                                        <strong>Atenção!</strong>
                                        O tamanho máximo e indicado para a
                                        <strong>Imagem</strong> é de
                                        <strong>500kb</strong>.
                                    </div>
                                    <file-image v-model="file" :arquivo="model.arquivo"></file-image>
                                </div>
                            </div>
                        </div>

                        <div class="card-footer text-right">
                            <router-link :to="{ name: 'list-post' }" class="btn btn-link">Cancelar</router-link>
                            <button type="submit" class="btn btn-primary">Salvar</button>
                        </div>
                    </div>
                    <dw-select-add
                        :url-select="'post/pesquisa'"
                        :opt-text="'titulo'"
                        :title="'Posts Relacionados'"
                        :model-name="'post-relacionado'"
                        :model-id="model.id"
                        :param-name="'post'"
                        :param-label="'titulo'"
                        :object-list="'relacionados'"
                        :draggable="false"
                        v-if="model.id"
                    ></dw-select-add>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import Facade from "../../facade/facade";
const facade = new Facade();
import {
    required,
    minLength,
    maxLength,
    withParams,
    email
} from "vuelidate/lib/validators";
import {
    isNotUndefinedOrNullOrEmptyOrZero,
    isUndefinedOrNullOrEmpty
} from "@/services/string";
import Select2 from "../../components/Input/Select2";
import SelectApi from "../../components/Input/SelectApi";
import Select from "../../components/Input/Select";
import FileImage from "../../components/Input/FileImage";
import { isPhone, isCpf, validateCPF } from "@/services/util";
import Collections from "../../helpers/collections";

export default {
    components: {
        FileImage,
        Select2,
        SelectApi,
        Select
    },
    data() {
        return {
            model: {
                id: null,
                titulo: "",
                data: moment().format("YYYY-MM-DD"),
                autor: "",
                conteudo: "",
                tipo: "",
                id_categoria: null,
                url: null,
                arquivo: null,
                imagem: null,
                idioma: null
            },
            file: null,
            tipos: Collections.tiposPost,
            tiposIdioma: Collections.idiomas
        };
    },
    validations() {
        let vm = this;

        return {
            model: {
                titulo: {
                    required,
                    minLength: minLength(2)
                },
                id_categoria: {
                    required,
                    isNotUndefinedOrNullOrEmptyOrZero
                },
                tipo: {
                    required,
                    isNotUndefinedOrNullOrEmptyOrZero
                },
                idioma: {
                  required,
                  isNotUndefinedOrNullOrEmptyOrZero
                }
            }
        };
    },
    methods: {
        async handleImageAdded(file, Editor, cursorLocation, resetUploader) {
            var formData = new FormData();
            formData.append("imagem", file);

            let ret = await facade.createPostImage(formData);
            console.log(ret);
            Editor.insertEmbed(cursorLocation, "image", ret.data.data.url);
            resetUploader();
        },
        async save() {
            let vm = this;
            if (this.$v.model.$invalid) {
                this.$v.model.$touch();
                this.$notify.warning(
                    "Atenção!",
                    "Verifique se todos os campos estão preenchidos corretamente."
                );
                return;
            }

            this.$loading.show(true);

            try {
                const formData = new FormData();
                formData.append("data", JSON.stringify(vm.model));
                formData.append("imagem", vm.file);

                let ret = null;

                if (vm.model.id) {
                    ret = await facade.updatePost(formData, vm.model.id);
                    this.$router.push({ name: "list-post" });
                } else {
                    ret = await facade.createPost(formData);
                    vm.model.id = ret.data.data.id;
                    this.$notify.success("Criado com sucesso.");
                }

                this.$loading.show(false);
            } catch (e) {
                e.forEach(item => {
                    this.$notify.error(item.field, item.message);
                });
                this.$loading.show(false);
            }
        },
        throwError(e) {
            this.$notify.error("Erro!", e);
        },
        setData(post) {
            if (post !== undefined && post !== null) {
                this.model = post;
            }
        }
    },
    beforeRouteEnter(to, from, next) {
        const vm = this;
        Promise.all([to.params.id ? facade.getPost(to.params.id) : null])
            .then(response => {
                next(vm =>
                    vm.setData(
                        response[0] != null ? response[0].data.data : null
                    )
                );
            })
            .catch(e => {
                next(vm => vm.setData());
            });
    }
};
</script>



// WEBPACK FOOTER //
// Form.vue?b7d4d8c6